module.exports = __webpack_public_path__ + "img/creator-join-guide.c57cff87.png";